import request from '@/utils/request'
import qs from 'qs'
// const MOCK_URL: string = 'http://localhost:3000'
// const MOCK_URL: string = ''

const headers = {
  'Content-Type': 'application/json;charset=UTF-8'
}

// ******************* 列表 API ******************
// 标签 - 列表
export const getLabelList = (data: any) =>
  request({
    url: `/basicMaterial/tag`,
    method: 'get',
    params: data
  })

// 角标 - 列表
export const getTagList = (data: any) =>
  request({
    url: `/basicMaterial/subscript`,
    method: 'get',
    params: data
  })

// 资源分组 - 列表
export const getResourceList = (data: any) =>
  request({
    url: `/basicMaterial/resourceGroup`,
    method: 'get',
    params: data
  })
// 标签-所属类别
export function getLabelCategory() {
  return request({
    url: `/basicMaterial/tag/category`,
    method: 'get'
  })
}
// 角标 - 类别
export function getTagCategory() {
  return request({
    url: `/basicMaterial/subscript/category`,
    method: 'get'
  })
}
// 资源分组平台 - 类别
export const getPlatformCategory = () =>
  request({
    url: `/basicMaterial/platform`,
    method: 'get'
  })

// ******************* 操作 API *********************
// 标签 - 新增/批量新增
export const addLabel = (data: IReqLabel) =>
  request({
    url: '/basicMaterial/tag',
    method: 'post',
    data: qs.stringify(data)
  })
// 标签 - 删除
export const deleteLabel = (data: any) =>
  request({
    url: '/basicMaterial/delTag',
    method: 'post',
    data: qs.stringify(data)
  })
// 角标 - 新增/修改
export const addTag = <T extends IReqLabel>(data: T) =>
  request({
    url: '/basicMaterial/subscript',
    method: 'post',
    data: qs.stringify(data)
  })
// 角标 - 删除
export const deleteTag = (data: any) =>
  request({
    url: '/basicMaterial/delSubscript',
    method: 'post',
    data: qs.stringify(data)
  })
// 资源分类 - 新增/修改
export const addResource = (data: Omit<IReqLabel, 'category'>) =>
  request({
    url: '/basicMaterial/resourceGroup',
    method: 'post',
    data: qs.stringify(data)
  })
// 资源分类 - 删除
export const deleteResource = (data: any) =>
  request({
    url: '/basicMaterial/delResourceGroup',
    method: 'post',
    data: qs.stringify(data)
  })

// 通过分类ID获取其子分类列表
export const getCategories = ({ platform, ...params }: any) =>
  request({
    url: `/basicMaterial/${platform === 'ios' ? 'categoryManageList' : 'androidCategoryManageList'}`,
    method: 'get',
    params
  })

// 新增/修改分类
export const addEditCategory = ({ platform, ...data }: any) =>
  request({
    url: `/basicMaterial/${platform === 'ios' ? 'saveCategory' : 'saveAndroidCategory'}`,
    method: 'post',
    headers,
    data
  })

// 删除分类
export const deleteCategory = ({ platform, ...data }: any) =>
  request({
    url: `/basicMaterial/${platform === 'ios' ? 'deleteCategory' : 'deleteAndroidCategory'}`,
    method: 'post',
    headers,
    data
  })
